// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_1NLtb","container":"index_container_3V3Hj","googleSign":"index_googleSign_hn2bq","footerNav":"index_footerNav_WD42U"};